import { HttpRequest, HttpMethod } from "./http";

class PlatformStatementProvider extends HttpRequest {

    // Upload platform statement file
    UploadStatement(params) {
        return this.request(HttpMethod.Post, `/api/v1/platform-statement/upload`, params);
    }

    // Get statement list with pagination
    ListStatements(page, limit, params) {
        return this.request(HttpMethod.Get, `/api/v1/platform-statement/list/${page}/${limit}`, params);
    }

    // Get statement detail by ID
    GetStatement(id) {
        return this.request(HttpMethod.Get, `/api/v1/platform-statement/${id}`);
    }

    // Search statement by statement number
    SearchStatement(statementNumber) {
        return this.request(HttpMethod.Get, `/api/v1/platform-statement/search/${statementNumber}`);
    }

    // Get summary report (generic - deprecated, use platform-specific endpoints)
    GetSummary(params) {
        return this.request(HttpMethod.Get, `/api/v1/platform-statement/summary`, params);
    }

    // Get TikTok summary report
    GetTikTokSummary(params) {
        return this.request(HttpMethod.Get, `/api/v1/platform-statement/summary/tiktok`, params);
    }

    // Get Shopee summary report
    GetShopeeSummary(params) {
        return this.request(HttpMethod.Get, `/api/v1/platform-statement/summary/shopee`, params);
    }

    // Get Lazada summary report
    GetLazadaSummary(params) {
        return this.request(HttpMethod.Get, `/api/v1/platform-statement/summary/lazada`, params);
    }

    // Get platform-specific summary based on platform_id
    GetPlatformSummary(platformId, params) {
        const platformEndpoints = {
            2: '/api/v1/platform-statement/summary/tiktok',
            3: '/api/v1/platform-statement/summary/shopee',
            4: '/api/v1/platform-statement/summary/lazada'
        };
        const endpoint = platformEndpoints[platformId];
        if (!endpoint) {
            return Promise.reject(new Error('Invalid platform_id'));
        }
        return this.request(HttpMethod.Get, endpoint, params);
    }

    // Export statement to Excel
    ExportStatement(id) {
        return this.request(HttpMethod.Get, `/api/v1/platform-statement/${id}/export`, null, {
            responseType: 'blob'
        });
    }

    // Delete statement
    DeleteStatement(id) {
        return this.request(HttpMethod.Delete, `/api/v1/platform-statement/${id}`);
    }
}

export default PlatformStatementProvider;
